import axiosInstance from './axiosConfig';

class RecipeService {
  getRecipes(page = 1, limit = 10, status = '', search = '') {
  return axiosInstance.get('/recipes', {
    params: { page, limit, status, search }
  });
}

  getRecipeById(id) {
    return axiosInstance.get(`/recipes/${id}`);
  }

  getRecipeByMenuId(menuId) {
    return axiosInstance.get(`/recipes/menu/${menuId}`);
  }

  createRecipe(data) {
    return axiosInstance.post('/recipes', data);
  }

  updateRecipe(id, data) {
    return axiosInstance.put(`/recipes/${id}`, data);
  }

  deleteRecipe(id) {
    return axiosInstance.delete(`/recipes/${id}`);
  }
}

const recipeService = new RecipeService();
export default recipeService;
